import styled, { css } from 'styled-components';
import { CampaignDateButtonProps } from 'models/campaign-mkt';
import CalendarIconImage from 'assets/img/campanhas-de-marketing/nova-campanha/icon-calendar.svg';

export const DateLabel = styled.span`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 16px;
  max-width: calc(100% - 76px);
  padding: 0 3px;
  overflow: hidden;
  background: #fbfbfb;
  color: #6a6f77;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform: translateY(-50%);
  transition: top 120ms ease, font-size 120ms ease;
`;

const floatingLabel = css`
  top: 0;
  max-width: calc(100% - 36px);
  font-size: 12px;
  line-height: 16px;
`;

export const DateButton = styled.button<CampaignDateButtonProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 52px;
  border: 1px solid ${({ $error }) => ($error ? '#d20003' : '#6a6f77')};
  border-radius: 16px;
  padding: 14px 16px;
  outline: 0;
  background: #fbfbfb;
  color: ${({ $error }) => ($error ? '#d20003' : '#33373c')};
  font-family: 'Roboto Flex', sans-serif;
  font-size: 14px;
  line-height: 24px;
  text-align: left;

  ${({ $filled }) =>
    $filled &&
    css`
      ${DateLabel} {
        ${floatingLabel}
      }
    `}

  &:focus ${DateLabel} {
    ${floatingLabel}
  }

  ${({ $error }) =>
    $error &&
    css`
      ${DateLabel} {
        color: #d20003;
      }
    `}

`;

export const CalendarIcon = styled.span`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin-left: auto;
  background: currentColor;
  -webkit-mask: url(${CalendarIconImage}) center / contain no-repeat;
  mask: url(${CalendarIconImage}) center / contain no-repeat;
`;

export const DatePickerWrapper = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle {
    right: auto !important;
    left: 74% !important;
    transform: translateX(-50%) !important;
  }
`;

export const DateError = styled.p`
  margin: 5px 16px 0;
  color: #d20003;
  font-size: 12px;
  line-height: 16px;
`;
